import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import classnames from 'classnames';

import { ICannedResponsesButtonProps } from './CannedResponsesButton.interface';

import './style.scss';

const CannedResponsesButton: FC<ICannedResponsesButtonProps> = ({ className, onClick }) => {
  const { t } = useTranslation();

  return (
    <Button className={classnames('canned-responses-button', className)} onClick={onClick}>
      <img className="canned-responses-button__icon" src="/images/img-cannedresponses.svg" />
      <span className="canned-responses-button__text">{t('adminInquiries.cannedResponses')}</span>
    </Button>
  );
};

export default CannedResponsesButton;
